import React, { Component } from 'react';
import { MDBContainer, MDBIframe } from "mdbreact";

class MediaView extends Component {
    constructor(props) {
        super(props);
        this.props.loaderOff();
    }

    render() {
        let url = "https://tupp.tuppafrica.co.za/" + this.props.location.state.folder + "/" + this.props.location.state.mediaId + "." + this.props.location.state.extension
        return (

            <MDBContainer className="text-center">
                <MDBIframe src={url} />
            </MDBContainer>
        );
    }
}

export default MediaView;